module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0125.jpg?v=6a735ba4";